import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { UpdateObligationInternalAuditResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateObligationInternalAuditResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type UpdateObligationInternalAuditResultInput = {
  Id: string;
  Rating?: number | null;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateObligationInternalAuditResult = createMutationHook({
  name: 'updateObligationInternalAuditResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditResult.updateObligation.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: UpdateObligationInternalAuditResultInput) => input,
  mapResponse: (): UpdateObligationInternalAuditResultMutation => ({
    update_obligation_internal_audit_result: {
      __typename: 'obligation_internal_audit_result_mutation_response',
      affected_rows: 1,
    },
  }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
  ],
  graphqlDocument: UpdateObligationInternalAuditResultDocument,
  graphqlVariables: (input: UpdateObligationInternalAuditResultInput) => ({
    ...input,
  }),
  evictFields: [
    'obligation_internal_audit_result',
    'internal_audit_report',
    'obligation_internal_audit_result_aggregate',
  ],
});
